// extracted by mini-css-extract-plugin
export default {"floatingButton":"WhatsAppFloat_floatingButton__Q6BDz","icon":"WhatsAppFloat_icon__VgtrN"};